import { render, staticRenderFns } from "./storeBNumIcon.vue?vue&type=template&id=c2a2bfae&"
import script from "./storeBNumIcon.vue?vue&type=script&lang=js&"
export * from "./storeBNumIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports